/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Work_Activity_File_RequiredInputs */

const vi_error_work_activity_file_required = /** @type {(inputs: Error_Work_Activity_File_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa chọn tệp để tải lên.`)
};

/**

* @param {Error_Work_Activity_File_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_work_activity_file_required = /** @type {((inputs?: Error_Work_Activity_File_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Work_Activity_File_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_work_activity_file_required(inputs)
});